<template>
  <div class="c-email-app mb-4">
    <div class="c-body flex-row">
      <email-nav />
      <main class="flex-shrink-1">
        <mail-toolbar />
        <ul class="c-messages">
          <inbox-message />
          <inbox-message read />
          <inbox-message read />
          <inbox-message />
          <inbox-message read />
          <inbox-message />
          <inbox-message read />
          <inbox-message read />
          <inbox-message read />
          <inbox-message read />
          <inbox-message read />
          <inbox-message />
          <inbox-message read />
        </ul>
      </main>
    </div>
  </div>
</template>

<script>
import EmailNav from './EmailNav';
import InboxMessage from './InboxMessage';
import MailToolbar from './MailToolbar';

export default {
  name: 'Inbox',
  components: {
    EmailNav,
    InboxMessage,
    MailToolbar,
  },
};
</script>
